import React, {createContext, useCallback, useContext, useState} from 'react'

type ChatbotContextType = {
  isOpen: boolean
  isFullscreen: boolean
  /** Open the widget from anywhere under the provider (e.g. the header Support button). */
  openChatbot: () => void
  closeChatbot: () => void
  toggleFullscreen: () => void
}

const ChatbotModalContext = createContext<ChatbotContextType | null>(null)

export const ChatbotModalProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [isFullscreen, setIsFullscreen] = useState(false)

  const openChatbot = useCallback(() => {
    setIsOpen(true)
  }, [])

  const closeChatbot = useCallback(() => {
    setIsOpen(false)
  }, [])

  const toggleFullscreen = useCallback(() => {
    setIsFullscreen((p) => !p)
  }, [])

  return (
    <ChatbotModalContext.Provider
      value={{
        isOpen,
        isFullscreen,
        openChatbot,
        closeChatbot,
        toggleFullscreen,
      }}
    >
      {children}
    </ChatbotModalContext.Provider>
  )
}

export const useChatbotModalContext = () => {
  const ctx = useContext(ChatbotModalContext)
  if (!ctx) throw new Error('useChatbotModalContext must be used within ChatbotModalProvider')
  return ctx
}

/** Nullable variant for components that may render outside the provider (e.g. layout header). */
export const useOptionalChatbotModalContext = () => useContext(ChatbotModalContext)

export default ChatbotModalContext
